import { render, staticRenderFns } from "./NovoCadastro.vue?vue&type=template&id=03a016c7&"
import script from "./NovoCadastro.vue?vue&type=script&lang=js&"
export * from "./NovoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./NovoCadastro.vue?vue&type=style&index=0&id=03a016c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports